import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StringMap } from 'i18next'
import { PointedFingerIcon } from 'Assets/icons/PointedFingerIcon'
import { Button, DesignedModal, StyledText } from '@clickcease/cc-client-components-lib'
import { Setup } from 'Features/domainsManagement/components/Setup/Setup'
import {
  ModalTitleWrapper,
  ModalTitle,
  ModalBody,
  ModalBodyTitle,
  ModalBodyItemWrapper,
  ModalBodyItemTitle,
  ModalBodyItemCard,
  ModalBodyItemsWrapper,
  ModalBodyItemCardHeader,
  ModalBodyItemCardBody,
  ModalBodyItemDescription,
} from './MigrationWelcomeModal.styled'

const STEPS = [1, 2]

export const MigrationWelcomeModal = () => {
  const { t } = useTranslation('limitedOfferBanner')
  const [isOpen, setIsOpen] = useState(true)

  const translate = (key: string, options?: StringMap) => t(`first_login_modal.${key}`, options)

  const title = (
    <ModalTitleWrapper>
      <ModalTitle>{translate('title.1')}</ModalTitle>
      <ModalTitle emphasis>{translate('title.2')}</ModalTitle>
      <ModalTitle>{translate('title.3')}</ModalTitle>
    </ModalTitleWrapper>
  )

  return (
    <DesignedModal
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      title={title}
      actions={<Button text={translate('button')} onClick={() => setIsOpen(false)} />}
    >
      <ModalBody>
        <ModalBodyTitle>{translate('body_title')}</ModalBodyTitle>
        <ModalBodyItemsWrapper>
          {STEPS.map((step) => (
            <ModalBodyItemWrapper key={step}>
              <ModalBodyItemTitle>{translate(`steps.${step}.step`)}</ModalBodyItemTitle>
              <ModalBodyItemDescription>
                {translate(`steps.${step}.description`)}
              </ModalBodyItemDescription>

              <ModalBodyItemCard>
                <ModalBodyItemCardHeader>
                  <StyledText variant="baseBold">{translate(`steps.${step}.col_1`)}</StyledText>
                  <StyledText variant="baseBold">{translate(`steps.${step}.col_2`)}</StyledText>
                </ModalBodyItemCardHeader>
                <ModalBodyItemCardBody firstItem={step === STEPS[0]}>
                  <StyledText variant="baseLight">{translate(`domain`)}</StyledText>
                  {step === STEPS[0] && (
                    <Button variant="ghost" text={translate(`steps.${step}.action`)} />
                  )}
                  {step === STEPS[1] && <Setup />}
                  <PointedFingerIcon />
                </ModalBodyItemCardBody>
              </ModalBodyItemCard>
            </ModalBodyItemWrapper>
          ))}
        </ModalBodyItemsWrapper>
      </ModalBody>
    </DesignedModal>
  )
}
